import { Alert, AlertAction } from './actions';
import {
    ALERT_DATA,
    ALERT_DELETE,
    ALERT_PUSH,
} from './constants';

export interface AlertState {
    alert: Alert | null;
}

export const initialAlertState: AlertState = { alert: null };

export const alertReducer = (state = initialAlertState, action: AlertAction) => {
    switch (action.type) {
        case ALERT_DATA:
            return {
                alert: action.payload,
            };
        case ALERT_DELETE:
            return {
                alert: null,
            };
        case ALERT_PUSH:
        default:
            return state;
    }
};